import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "notifications-page"
};
const _hoisted_2 = { class: "notif-section" };
const _hoisted_3 = { class: "notif-card" };
const _hoisted_4 = { class: "notif-card" };
const _hoisted_5 = { class: "notif-section" };
const _hoisted_6 = { class: "notif-card" };
import { onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGToggle from './elements/MGToggle.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NotificationsPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer, savePreferences } = useCustomer();
        function onLoad() {
            getCustomer(() => {
                if (state.customer && state.customer.preferences == null) {
                    state.customer.preferences = { dailyCurrentBalanceNotifications: false, dailyCreditBalanceNotifications: false, quizNotifications: false };
                }
            });
        }
        function savePrefs() {
            savePreferences(() => {
                if (state.customer && state.customer.preferences == null) {
                    state.customer.preferences = { dailyCurrentBalanceNotifications: false, dailyCreditBalanceNotifications: false, quizNotifications: false };
                }
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Notifications" }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "notif-section-title" }, "Daily balance update", -1)),
                                    _createElementVNode("div", _hoisted_3, [
                                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "notif-label" }, "Current Accounts", -1)),
                                        _createVNode(MGToggle, {
                                            modelValue: _unref(state).customer.preferences.dailyCurrentBalanceNotifications,
                                            "onUpdate:modelValue": [
                                                _cache[0] || (_cache[0] = ($event) => ((_unref(state).customer.preferences.dailyCurrentBalanceNotifications) = $event)),
                                                savePrefs
                                            ]
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_4, [
                                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "notif-label" }, "Credit Cards", -1)),
                                        _createVNode(MGToggle, {
                                            modelValue: _unref(state).customer.preferences.dailyCreditBalanceNotifications,
                                            "onUpdate:modelValue": [
                                                _cache[1] || (_cache[1] = ($event) => ((_unref(state).customer.preferences.dailyCreditBalanceNotifications) = $event)),
                                                savePrefs
                                            ]
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "notif-description" }, "Keep on top of your spending. We'll send you a summary each morning of your balances.", -1))
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "notif-section-title" }, "Other notifications", -1)),
                                    _createElementVNode("div", _hoisted_6, [
                                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "notif-label" }, "Quiz updates and reminders", -1)),
                                        _createVNode(MGToggle, {
                                            modelValue: _unref(state).customer.preferences.quizNotifications,
                                            "onUpdate:modelValue": [
                                                _cache[2] || (_cache[2] = ($event) => ((_unref(state).customer.preferences.quizNotifications) = $event)),
                                                savePrefs
                                            ]
                                        }, null, 8, ["modelValue"])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
